import { useField } from "formik";
import { useEffect, useState } from "react";
import _promoCodes from "../../../_shared/constants/promoCodes";

type Props = {
  promoCodes: typeof _promoCodes;
  planPrice: number;
  addonsPrice: number;
};

const PromoInput = ({ promoCodes, planPrice, addonsPrice }: Props) => {
  const [tempPromo, setTempPromo] = useState("");
  const [{ value, onChange }, { error }] = useField<string>("promo");
  const [discount, setDiscount] = useState<number>();
  const [trial, setTrial] = useState<number>();

  useEffect(() => {
    if (error) return;
    const foundPromo = promoCodes.find((promo) => promo.promo === value);
    if (!foundPromo) return;
    setDiscount(foundPromo.discount);
    setTrial(foundPromo.trial);
  }, [error, promoCodes, value]);

  return (
    <div>
      {" "}
      <div className="promo-box">
        <div style={{ textAlign: "left", marginTop: 5, marginBottom: 5 }}>
          Promo Code
        </div>
        <div className="input-container-promo">
          <input
            aria-label="Promo code"
            name="promo"
            placeholder="Enter Promo Code Here"
            className="promo-textbox"
            value={tempPromo}
            onChange={(e) => setTempPromo(e.target.value.toUpperCase())}
            data-testid="input-promocode"
          />
          <span
            onClick={() => {
              onChange("promo")(tempPromo);
            }}
            style={{
              color: "#75ce41",
              height: "33px",
              padding: "2px 16px",
              fontSize: "15px",
              cursor: "pointer",
              position: "relative",
              left: window.matchMedia("(max-width: 480px)").matches
                ? "110px"
                : "400px",
              bottom: "36px",
            }}
          >
            Apply
          </span>
          <div
            style={{
              position: "relative",
              top: -20,
              fontStyle: "italic",
              color: "#d33541",
            }}
          >
            {error || ""}
          </div>
        </div>
        <div className="promo-text">
          <p>
            {discount
              ? `You get ${discount}% off for one month with this promo code`
              : ` `}
          </p>
          <p>
            {trial ? `You get a ${trial} day trial with this promo code` : ` `}
          </p>
        </div>
        <div className="promo-price">
          {/* TODO: why is the promo code value for a trial hardcoded at $10? */}
          {trial
            ? `Promo Code Value: $10`
            : `Your total: $${discount ? "0" : planPrice + addonsPrice}
      `}
        </div>
      </div>
    </div>
  );
};

export default PromoInput;
